import * as React from "react";

import {
  InitialStateMinimumRequirements_Analytics,
  InitialStateMinimumRequirements_StaticMedia,
} from "../../../Common";

interface ReactPlpInitialStateConsumerInterface {
  initialState: ReactPlpInitialStateInterface;
}

export interface BreadcrumbCrumbDescription {
  label?: string;
  title?: string;
  link?: string;
  first?: boolean;
  last?: boolean;
}

interface ReactPlpInitialStateInterface
  extends InitialStateMinimumRequirements_Analytics,
    InitialStateMinimumRequirements_StaticMedia {
  baseQuery?: {
    cat_id?: string;
    search?: string;
  };
  bannerConfiguration?: {
    image?: {
      desktop?: string;
      tablet?: string;
      mobile?: string;
    };
  };
  breadcrumbsDescription?: {
    crumbs?: {
      [key: string]: BreadcrumbCrumbDescription;
    };
  };
  pageConfiguration: {
    pageTitle?: string;
  };
}

const defaultValue = {} as unknown as ReactPlpInitialStateConsumerInterface;

const ReactPlpInitialStateContext = React.createContext(defaultValue);

interface ReactPlpInitialStateProviderProps {
  mountElement: Element | null;
  children?: React.ReactNode;
}

export const ReactPlpInitialStateProvider: React.FunctionComponent<
  ReactPlpInitialStateProviderProps
> = (props) => {
  const mountElement = (props?.mountElement || {}) as HTMLElement;
  const initialStateJsonString =
    mountElement?.dataset.reactPlp__initialstate || "{}";
  const initialState = JSON.parse(
    initialStateJsonString
  ) as ReactPlpInitialStateInterface;
  const value: ReactPlpInitialStateConsumerInterface = React.useMemo(
    () => ({
      initialState,
    }),
    []
  );
  return (
    <ReactPlpInitialStateContext.Provider value={value}>
      {props?.children || []}
    </ReactPlpInitialStateContext.Provider>
  );
};

export const useReactPlpInitialState = () => {
  const context = React.useContext(ReactPlpInitialStateContext);
  if (context === defaultValue) {
    throw new Error(
      "useReactPlpInitialState must be used within a ReactPlpInitialStateProvider"
    );
  }
  return context;
};
